<template>
    <div>
      <div class="faq-question" @click="toggleAnswer">{{ question }}</div>
      <div v-if="showAnswer" v-html="answer" class="faq-answer">{{ answer }}<br></div>
      
    </div>
  </template>
  
  <script>
  export default {
    props: {
      question: String,
      answer: String,
    },
    data() {
      return {
        showAnswer: false,
      };
    },
    methods: {
      toggleAnswer() {
        this.showAnswer = !this.showAnswer;
      },
    },
  };
  </script>
  
  <style scoped>
  .faq-question {
    cursor: pointer;
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: bold;
    background-color: #f9f9f9;
    padding: 10px;
    border-radius: 5px;
    transition: background-color 0.3s;
  }
  
  .faq-answer {
    display: block;
    margin-left: 20px;
    font-size: 14px;
    line-height: 200%;
    color: #555;
  }
  
  .faq-answer.show {
    display: block;
  }
  
  .faq-question:hover {
    background-color: #e0e0e0;
  }
  </style>
  